import { render, staticRenderFns } from "./PasswordChangePage.vue?vue&type=template&id=41595d62&scoped=true&"
import script from "./PasswordChangePage.vue?vue&type=script&lang=ts&"
export * from "./PasswordChangePage.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordChangePage.vue?vue&type=style&index=0&id=41595d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41595d62",
  null
  
)

export default component.exports